import React, { Component } from "react";
import KpsEditor from "../editor/KpsEditor";
import escapeHtml from "escape-html";
import { withStyles } from "@material-ui/core/styles";
import HtmlDiff from "./htmldiff/Diff";

const styles = (theme) => ({
  code: {
    fontFamily: "monospace",
    backgroundColor: "#eee",
    padding: 3,
  },
});
export class TextSection extends Component {
  render() {
    let contentCss = {};
    if (this.props.section.css) {
      let css = JSON.parse(this.props.section.css);
      contentCss = css.content;
      if (css && css.content && css.content.colour) {
        contentCss.color = css.content.colour;
        contentCss.fontFamily =
          css.content.fontStyle + ", " + css.content.fontGeneric;
      }
    }
    return (
      <div style={contentCss} aria-label="Section content">
        {this.props.isDiff ? (
          <>
            {this.props.diffSection ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: this.getDiff(),
                }}
              />
            ) : null}
          </>
        ) : (
          <KpsEditor
            contentCreation={this.props.contentCreation}
            onChange={this.props.onChange}
            textSection
            initialContent={this.props.section.defaultText}
            customFields={this.props.customFields}
            readOnly
            editSection={this.props.editSection && this.editSection}
            placeholder={this.props.placeholder}
            resize
            onRenderComplete={this.props.onRenderComplete}
            sectionId={this.props.section.sectionID}
            updateUploadArray={this.editSectionWithArray}
          />
        )}
        {this.props.children}
      </div>
    );
  }
  editSection = (text) => {
    let section = this.props.section;
    section.defaultText = text;
    this.props.editSection(section);
  };
  editSectionWithArray = (array) => {
    let section = this.props.section;
    section.attachmentIds = array;
    this.props.editSection(section);
  };
  getDiff = () => {
    let diffText = this.props.diffSection.defaultText;
    let thisText = this.props.section.defaultText;
    if (!diffText) {
      diffText = "";
    }
    if (!thisText) {
      thisText = "";
    }
    // HtmlDiff does not work if you use the minified version
    // for some reason it throws "undefined is not iterable" which is a reasonable error,
    // but is absolutely impossible to debug because the minified version has been
    // compiled with babel and is a disaster to try to read when the error occurs
    // in a generator function. If instead you copy the entirety of the library's source
    // code and have webpack minify it like our code not only is it easier to debug
    // but it also never throws the error in the first place and actually works.
    // The moral of this story is do not try and use the pre-minified version
    // from node_modules because it will not work and you will waste hours like me
    return HtmlDiff.execute(diffText, thisText);
  };
}
export default withStyles(styles)(TextSection);
